export default __webpack_public_path__ + "media/Veggies-Vegetable.08c4f92e.png";